// third-party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// project imports
import snackbarReducer from './slices/snackbar';
import dataReducer from './slices/data';
import menuReducer from './slices/menu';
import backdropReducer from './slices/backdrop';
import deploymentsReducer from './slices/deployments';
import userReducer from './slices/users';
import logsReducer from './slices/logs';
import trialRequestsReducer from './slices/trial-requests';
import deploymentRequestsReducer from './slices/deployment-requests';
import clientsReducer from './slices/clients';
import unitsReducer from './slices/units';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    snackbar: snackbarReducer,
    data: persistReducer(
        {
            key: 'data',
            storage,
            keyPrefix: 'rpl-robot-'
        },
        dataReducer
    ),
    menu: menuReducer,
    backdrop: backdropReducer,
    deployments: deploymentsReducer,
    users: userReducer,
    logs: logsReducer,
    trialRequests: trialRequestsReducer,
    deploymentRequests: deploymentRequestsReducer,
    clients: clientsReducer,
    units: unitsReducer
});

export default reducer;
